import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Gauge, Truck, ClipboardList, FileText, Users, LogOut, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Panel", icon: Gauge, end: true },
  { to: "/admin/maquinaria", label: "Maquinaria", icon: Truck },
  { to: "/admin/cotizaciones", label: "Cotizaciones", icon: ClipboardList },
  { to: "/admin/contratos", label: "Contratos", icon: FileText },
  { to: "/admin/usuarios", label: "Usuarios", icon: Users },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-background flex">
      <aside className="w-60 shrink-0 bg-[#0A0A0A] text-white flex flex-col border-r border-white/10 sticky top-0 h-screen">
        <Link to="/" className="flex items-center gap-2 px-5 h-16 border-b border-white/10">
          <div className="h-8 w-8 bg-brand flex items-center justify-center font-display font-black text-black text-xl">M</div>
          <span className="font-display font-black text-xl tracking-tighter">MAQUI<span className="text-brand">PRO</span></span>
        </Link>
        <nav className="flex-1 py-4">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-3 text-sm font-medium transition-colors ${isActive ? "bg-brand text-black" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
              <Icon size={18} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <Link to="/" className="flex items-center gap-2 text-xs text-white/50 hover:text-brand mb-3 transition-colors">
            <ArrowUpRight size={14} /> Ver sitio público
          </Link>
          <div className="text-xs text-white/40 mb-2 truncate">{user?.email}</div>
          <button onClick={logout} data-testid="admin-logout" className="flex items-center gap-2 text-sm font-semibold text-red-400 hover:text-red-300">
            <LogOut size={16} /> Cerrar sesión
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="h-16 border-b border-border flex items-center justify-between px-6 sticky top-0 bg-background/80 backdrop-blur-xl z-40">
          <div className="font-display font-bold text-lg tracking-tight">Administración</div>
          <ThemeToggle />
        </header>
        <main className="p-6"><Outlet /></main>
      </div>
    </div>
  );
}
